export default __webpack_public_path__ + "static/media/interpol.59da99bc.webp";